import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';
import type { ShareFormPayload } from '../types';

/** Configures audience/recipients/expiration, creates a version snapshot, and distributes it — one call. */
export function useShareForm(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: ShareFormPayload) => formsService.share(formId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.sharing(orgId ?? '', formId) });
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.detail(orgId ?? '', formId) });
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.byOrg(orgId ?? '') });
    },
  });
}
